import { TableCell } from "@/components/ui/Table";
import { TableRow } from "@/components/ui/Table";
import { BodyText } from "@/components/ui/Text/BodyText";
import { AoeQuestionAnswerType } from "@/features/Charting/components/Labs/types";
import type {
  Answer,
  AnswerCoding,
  QuestionnairesWithResponses,
} from "../../network/useDxReportOrderAOE";

export const AOEQuestionnaire = ({
  questionnaireResponse,
}: {
  questionnaireResponse: QuestionnairesWithResponses;
}) => {
  const formatAnswers = (answers: Answer[]) =>
    answers
      .map((answer) => {
        if (
          [AoeQuestionAnswerType.DATE, AoeQuestionAnswerType.TEXT].includes(
            answer.answerType,
          )
        ) {
          return answer.answerValue;
        }
        if (answer.answerType === AoeQuestionAnswerType.CODING) {
          return (answer.answerValue as AnswerCoding).display;
        }
        return answer.answerValue;
      })
      .join(", ");

  return (
    <>
      <TableRow>
        <TableCell colSpan={2} className="">
          <BodyText size="sm" bold>
            {questionnaireResponse.testName}
          </BodyText>
        </TableCell>
      </TableRow>
      {questionnaireResponse.questionResponses?.map((questionResponse) => (
        <TableRow key={questionResponse.linkId}>
          <TableCell>
            <BodyText size="sm">{questionResponse.question}</BodyText>
          </TableCell>
          <TableCell className="">
            <BodyText size="sm">
              {formatAnswers(questionResponse.answers)}
            </BodyText>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
